import { Component, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LdapService } from '@app/shared/services/api/ldap.service';
import { AuthService } from '@app/shared/services/auth.service';
import { HeaderFooterVisibilityService } from '@app/shared/services/header-footer-visibility.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { emailValidator, isEmailValid } from '@app/shared/utility';

@Component({
  selector: 'app-reset-password-request',
  templateUrl: './reset-password-request.component.html',
  styleUrls: ['./reset-password-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ResetPasswordRequestComponent {
  resetRequestForm = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator]),
  });

  showConfirmation = false;

  constructor(
    public overlayLoaderService: OverlayLoaderService,
    private ldapService: LdapService,
    public headerFooterVisibilityService: HeaderFooterVisibilityService,
    private authService: AuthService
  ) {}

  resetPassword() {
    const email = this.resetRequestForm.controls.email.value;

    if (email && isEmailValid(email)) {
      this.overlayLoaderService.isLoading = true;
      this.ldapService.resetPassword(email).subscribe({
        next: (a) => {
          this.overlayLoaderService.isLoading = false;
          this.showConfirmation = true;
        },
        error: () => {
          this.overlayLoaderService.isLoading = false;
          this.showConfirmation = false;
        },
      });
    }
  }

  cancel() {
    this.authService.login();
  }
}
